import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Record from '@/view/record/Record'

export default {
  path: '/record',
  name: 'Record',
  components: {
    default: Record,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record',
    breadcrumb: [
      { name: 'Cadastro' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/RecordRoute.js